import { render, staticRenderFns } from "./LanguageSummary.vue?vue&type=template&id=96246776&scoped=true&"
import script from "./LanguageSummary.vue?vue&type=script&lang=js&"
export * from "./LanguageSummary.vue?vue&type=script&lang=js&"
import style0 from "./LanguageSummary.vue?vue&type=style&index=0&id=96246776&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96246776",
  null
  
)

export default component.exports